export default __webpack_public_path__ + "static/media/attachments.4389235b.md";